module.exports = __webpack_public_path__ + "img/berryGlow1.38626d5a.jpg";